<template>
  <Modal
    :show="show"
    width="medium"
    hide-default-actions
    @close="show = false"
  >
    <template #activator>
      <div
        class="activator"
        @click="show = true"
      >
        Export
      </div>
    </template>

    <template #title>
      <div class="custom-title">
        Save your job in other formats.
      </div>
    </template>

    <template #content>
      <DpplToggleTabs
        v-model="tab"
        :tabs="['Export', 'Copy']"
      >
        <v-tabs-window-item value="Export">
          <div class="d-flex flex-column ga-4 text-textDarkest mt-4">
            <div class="d-flex">
              <v-icon
                icon="material-symbols-light:picture-as-pdf-outline"
                class="my-auto"
                size="20"
              />

              <div class="ml-2 my-auto">
                <div>
                  Export to PDF
                </div>
              </div>

              <v-btn
                class="ml-auto"
                variant="flat"
                color="primary"
                rounded="lg"
                height="32"
                @click="emits('export-to', 'pdf', 'PDF')"
              >
                Export
              </v-btn>
            </div>

            <div class="d-flex">
              <v-icon
                icon="material-symbols-light:docs-outline"
                class="my-auto"
                size="20"
              />

              <div class="ml-2 my-auto">
                Export to Microsoft Word
              </div>

              <v-btn
                class="ml-auto"
                variant="flat"
                color="primary"
                rounded="lg"
                height="32"
                @click="emits('export-to', 'word', 'Word')"
              >
                Export
              </v-btn>
            </div>

            <div class="d-flex">
              <v-icon
                icon="ph:brackets-angle"
                size="20"
              />

              <div class="ml-2 my-auto">
                <div>
                  Export to HTML
                </div>
                <div class="mt-1 text-caption opacity-70">
                  Works well with Microsoft Word, Google Docs and other apps.
                </div>
              </div>

              <v-btn
                class="ma-auto"
                variant="outlined"
                color="primary"
                rounded="lg"
                height="32"
                @click="emits('export-to', 'html', 'HTML')"
              >
                Export
              </v-btn>
            </div>

            <div class="d-flex">
              <v-icon
                icon="material-symbols-light:tag"
                size="20"
              />

              <div class="ml-2 my-auto">
                <div>
                  Export to Markdown
                </div>
                <div class="mt-1 text-caption opacity-70">
                  Works well with Notion, Github and other apps.
                </div>
              </div>

              <v-btn
                class="ma-auto"
                variant="outlined"
                color="primary"
                rounded="lg"
                height="32"
                @click="emits('export-to', 'markdown', 'Markdown')"
              >
                Export
              </v-btn>
            </div>
          </div>
        </v-tabs-window-item>

        <v-tabs-window-item value="Copy">
          <div class="d-flex flex-column ga-4 text-textDarkest mt-4">
            <slot name="copy-options" />
          </div>
        </v-tabs-window-item>
      </DpplToggleTabs>
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplToggleTabs from '@ui/components/general/DpplToggleTabs/DpplToggleTabs.vue';

defineProps({
  jobId: { type: [String, Number], default: '' },
  title: { type: String, default: '' },
  isDataLoaded: { type: Boolean, default: false },
});

const emits = defineEmits(['export-to']);

const show = ref(false);
const tab = ref('Export');
</script>

<style scoped lang="less">
// Stretch the click target over the wrapping button.
.activator::after {
  content: '';
  position: absolute;
  inset: 0;
}

.custom-title {
  color: fade(@grey-900, 70%);
  font-size: 13px;
  font-weight: 500;
}
</style>
